module.exports = __webpack_public_path__ + "azure-logo-be128f562590bfb1a568f048272c1757.webp";